<template>
  <div class="submain__terrenos-custom">
    <!-- <promotion-alert>
      24
     </promotion-alert> -->
    <div class="line__vertical-mains"></div>
    <sub-header :micrositeUrl="micrositeUrl" />
    <div v-if="locations.length > 0" class="map_filter">
      <div class="select__box box-terrenos">
        <!-- <Promotion class="promotion_mobile">24</Promotion> -->
        <Range class="ranges-mobile" v-if="locations.length > 0 && filtersCalculated" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
        <Availables
            class="availables-mobile"
            :type="type"
            :amountAvailables="amountAvailables"
        />
      </div>
      <div class="maphighlight__box">
          <h1 class="caption__select">
                  <span>Seleccione una terreno, clic para ver detalles</span>
                </h1>
        <map-highlight v-for="(img, index) in imgSet" :key="img.width" :index="index" :img="img"  :existFilter="existFilter" :desarrollo="desarrollo" :url="url" :nivel="nivel"/>
        <Button v-for="(img, index) in imgSet" :key="img.url" :index="index" :img="img"/>
        <div class="line_horizontal ranges-desk"></div>
        
      </div>
      <div class="select__box">
        <!-- <Select
            v-if="locations.length > 0 && rangeFilter.length > 0"
            :locations="locations"
            @change="changeRange"
            :rangeFilter="rangeFilter"
        /> -->
        <Availables
            class="availables-desk"
            :amountAvailables="amountAvailables"
            :type="type"
        />
        <Range class="ranges-desk" v-if="locations.length > 0 && filtersCalculated" :locations="locations" @change="changeRange" :rangeFilter="rangeSliderFilter" :rangeFilterPrice="rangeFilterPrice"/>  
        <!-- <Promotion class="promotion_web">24</Promotion> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import SubHeader from "../../core/SubHeader.vue";
import MapHighlight from "../../core/MapHighlight";
/* import Select from "../../core/Select.vue"; */
import Availables from "../../core/Availables.vue";
import Button from "../../core/Button.vue";
import Range from "../../core/Range.vue";
/* import PromotionAlert from "../../core/PromotionAlert.vue";
import Promotion from "../../core/Promotion.vue"; */
export default {
  name: "Main",
  components: {
    SubHeader,
    MapHighlight,
    /* PromotionAlert,
    Promotion, */
    /* Select, */
    Availables,
    Button,
    Range
  },
  data() {
    return {
      id: 63,
      levelId: 0,
      type:"terreno",
      desarrollo: "zonacomercialpradosur",
      arrFilteredLocations: [],
      nivel: "availability",
      url: "zcpradosur/detalles",
      micrositeUrl: "https://tresmarias.com.mx/zonacomercial/pradosur/",
      imgSet: [
        {
          name: 'zonacomercialpradosur',
          url: 'https://kiritek-web-documents.s3.us-west-2.amazonaws.com/masterplan-dashboard/imgs/pradosur/PM-PradoSurComercio.webp',
          width: '5146',
          height: '6869',
          id: 63,
          route: 'zcpradosur/detalles',
          nivel: 'availability',
          levelId: 0,
          transform: '',
          viewBox: '0 0 5146 6869'

        }
      ],
      // si no hay filtro volver rangeFilter a false
      rangeSliderFilter:[null,null],
            rangeFilterPrice:[null,null],
            rangeFilter: [
              { min: 0, max: 0 }
          ],
            filtersCalculated: false
    };
  },

  computed: {
    ...mapGetters({
      locations: "getLocations",
    }),
    development() {
      return { id: this.id, level: 0 };
    },
    amountAvailables() {
      const filteredAvailables = this.existFilter;
      const newArrfiltered = filteredAvailables.filter(
          (item) => item.status == 2
      );
      return newArrfiltered;
    },
    existFilter() {
      let arrExistFilter;
      if (this.rangeFilter) {
        arrExistFilter = this.arrFilteredLocations;
      } else if (this.rangeFilter === false) {
        arrExistFilter = this.locations;
      }
      return arrExistFilter;
    },
  },
  methods: {
    ...mapActions(["getAvailableLocations", "clearCoords"]),
    changeRange(arrFilter) {
      this.arrFilteredLocations = arrFilter;
    },
  },
  async created() {
    await this.clearCoords();
    await this.getAvailableLocations(this.development);

  },
  async beforeDestroy(){
    await this.clearCoords()
  },
  watch: {
    locations(newVal) {
      if (newVal.length > 0) {
        const m2tValues = newVal
          .filter(item => item.m2t != null)
          .map(item => Number(item.m2t));

        if (m2tValues.length > 0) {
          const min = Math.floor(Math.min(...m2tValues));
          const max = Math.ceil(Math.max(...m2tValues)); 

          this.rangeSliderFilter = [min, max];
        } else {
          this.rangeSliderFilter = [0, 0];
        }

        const prices = newVal.map(item => item.value);
        if (prices.length > 0) {
          const minPrice = Math.floor(Math.min(...prices));
          const maxPrice = Math.ceil(Math.max(...prices));

          this.rangeFilterPrice = [minPrice, maxPrice];
          const step = Math.ceil((maxPrice - minPrice + 1) / 3);

          this.rangeFilter = [
            { min: minPrice, max: minPrice + step - 1 },
            { min: minPrice + step, max: minPrice + step * 2 - 1 },
            { min: minPrice + step * 2, max: maxPrice },
          ];
          this.filtersCalculated = true;
        } else {
          this.rangeFilterPrice = [null, null];
          this.rangeFilter = [];
        }

        this.arrFilteredLocations = newVal;
      }
    }
  }
};
</script>

<style>
.caption__select, .select__box.box-terrenos {
  z-index: 1;
  position: relative;
  background: rgb(240 240 240);
}
</style>
